import React, {useCallback} from "react";
import {IForm} from "../../../libs/uiKit/fieldsBuilder/types";
import {PRODUCT_FLAT, RADIO_BOOLEAN, RADIO_SEX, RUSSIA_COUNTRY_ISN} from "../../../libs/utils/staticData";
import dayjs from "dayjs";
import {getSelectDefaultValue} from "../../../libs/utils/getSelectdefaultValue";
import {useFormContext} from "react-hook-form";
import {useUserRights} from "../common/hooks/useUserRights";
import {FieldsBuilder} from "../../../libs/uiKit/fieldsBuilder";
import {fieldsValidate} from "../../../libs/uiKit/fieldsBuilder/utils/fieldValidation";
import {useLazyQuery} from "@apollo/client";
import {SearchContragentQuery, SearchContragentQueryVariables} from "../../../libs/api/graphqlTypes";
import {SEARCH_CONTRAGENT} from "../../../libs/api/queries";
import {useParams} from "react-router-dom";
import useNitification from "../../widgets/notifier/ui/hooks/useNitification";
import {formatPersonDataToDataForm} from "../createAgreement/ds/repositories/commands";
import {Text4} from "../../../libs/uiKit/globalStyles";
import {StyledDocResult} from "../createAgreement/widgets/contragent/ui/styles";
import {IDaDataValue} from "../../../libs/uiKit/daData/types";
import {FORMAT_DATE} from "../../../libs/uiKit/utils";

const Contragent: React.FC<{
    arrayName: string;
    number: number;
    disabled?: boolean;
    disableBirthDate?: boolean;
    disableGender?: boolean;
}> = ({
    arrayName,
    number,
    disabled: contragentDisabled,
    disableBirthDate,
    disableGender,
}) => {

    const { rightsHandler } = useUserRights();
    const formHook = useFormContext();

    const { id } = useParams<{ id?: string }>();

    const [stateIsSearch, setIsSearch] = React.useState<boolean>(false);
    const [codeResults, setDocCodeResults] = React.useState<string[]|null>(null);

    const [searchContragent] = useLazyQuery<SearchContragentQuery, SearchContragentQueryVariables>(SEARCH_CONTRAGENT);

    const { setNotification } = useNitification();

    const [isSameAddress] = formHook.watch([`${arrayName}[${number}].addressRadio`]);


    const updateContragent = (prefix: string, data: any) => {
        Object.keys(data).forEach(key => {
            formHook.setValue(`${prefix}.${key}`, data[key]);
        });
        //formHook.trigger();
    }

    const searchByIsnHandler = React.useCallback(
        (isn: string) => {
            if (!isn || fieldsValidate({ value: isn, validationType: 'contragentIsn' })) return;
            setIsSearch(true);
            searchContragent({
                variables: {
                    id: id ? +id : 0,
                    isn,
                },
            })
                .then(({ data }) => {
                    if (!data?.searchContragent) return setNotification({ type: 'warn', text: 'Ничего не найдено' });
                    setNotification({ type: 'success', text: 'Информация найдена' });
                    //searchSuccessCallback(data.searchContragent, number);
                    const dataForForm = formatPersonDataToDataForm(data.searchContragent);
                    console.log({ dataForForm });
                    updateContragent(`${arrayName}[${number}]`, dataForForm);
                })
                .catch(error => setNotification({ type: 'error', text: error }))
                .finally(() => setIsSearch(false));
        },
        [formHook, arrayName, number, setNotification, searchContragent]
    );

    const searchByDocIssuerCode = (code: string) => {
        if (!code || fieldsValidate({ value: code, validationType: 'authDocIssuerCode' })) return;

        const dadataProxy = process.env.REACT_APP_DADATA_PROXY || '/dadata/?path=';
        const url = `${dadataProxy}/suggestions/api/4_1/rs/suggest/fms_unit`;
        const options: RequestInit = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                // Authorization: `Token ${dadataToken}`,
            },
            body: JSON.stringify({ query: code }),
        };
        fetch(url, options).then((response) => {
            if (response.status === 200) {
                response.json().then((json) => {
                    if(json?.suggestions){
                        formHook.setValue(`${arrayName}[${number}].authDocIssuer`, json?.suggestions[0]?.value);
                        if(json?.suggestions.length > 1){
                            setDocCodeResults(json?.suggestions?.map((item: any) => item?.value));
                        } else {
                            setDocCodeResults([]);
                        }
                    } else {
                        console.log('searchByDocIssuerCode: no found');
                    }
                });
                return null;
            }
        });

        return null;

    };

    const onCodeResultClick = (s: string) => {
        formHook.setValue(`${arrayName}[${number}].authDocIssuer`, s);
    }

    const detectSexByName = useCallback((fullName: IDaDataValue | null | undefined, genderField: string) => {
        const gender = fullName?.data?.gender;
        if(gender){
            formHook.setValue(genderField, gender === 'FEMALE' ? "F" : "M")
        }
    }, [formHook]);

    const searchHandler = React.useCallback(
        (searchProps: { currentFullName?: IDaDataValue | null; currentBirthDate?: Date | null; currentPhone?: string }) => {
            const searchData = {
                currentFullName: formHook.getValues(`${arrayName}[${number}].fullName`),
                currentBirthDate: formHook.getValues(`${arrayName}[${number}].birthDate`),
                currentPhone: formHook.getValues(`${arrayName}[${number}].phoneMobile`),
                ...searchProps,
            };
            const { currentFullName, currentBirthDate, currentPhone } = searchData;
            if (
                !currentFullName ||
                fieldsValidate({ value: currentFullName, validationType: 'fullName' }) ||
                !currentBirthDate ||
                fieldsValidate({ value: currentBirthDate, validationType: 'date' }) ||
                !currentPhone ||
                fieldsValidate({ value: currentPhone, validationType: 'phone' })
            )
                return;
            setIsSearch(true);
            searchContragent({
                variables: {
                    fullname: currentFullName.value,
                    birthday: dayjs(currentBirthDate).format(FORMAT_DATE),
                    phone: currentPhone,
                    id: parseInt(id || '', 10)
                },
            })
                .then(({ data }) => {
                    if (!data?.searchContragent) return;
                    setNotification({ type: 'success', text: 'Информация найдена' });
                    const dataForForm = formatPersonDataToDataForm(data.searchContragent);
                    updateContragent(`${arrayName}[${number}]`, dataForForm);
                })
                .catch(error => setNotification({ type: 'error', text: error }))
                .finally(() => setIsSearch(false));
        },
        [formHook, arrayName, number, setNotification, searchContragent]
    );

    const form: IForm = {
            formHook,
            isLoading: stateIsSearch,
            hotReload: true,
            fields: [
                {
                    field: {
                        fieldType: 'daData',
                        fieldName: `${arrayName}[${number}].fullName`,
                        placeholder: `Фамилия имя отчество`,
                        daDataType: 'fio',
                        isRequired: true,
                        grid: rightsHandler('searchContragentByIsn') ? 9 : 12,
                        onChange: currentValue => {
                            detectSexByName(currentValue, `${arrayName}[${number}].gender`);
                            searchHandler({ currentFullName: currentValue })
                        },
                        validationType: 'fullName',
                        errorMessage: 'Введите Ф.И.О',
                    },
                },
                {
                    isHidden: !rightsHandler('searchContragentByIsn'),
                    field: {
                        fieldType: 'input',
                        fieldName: `${arrayName}[${number}].contragentIsn`,
                        placeholder: 'Поиск по ISN',
                        onChange: ev => searchByIsnHandler(ev.target.value),
                        validationType: 'contragentIsn',
                        grid: 3,
                    },
                },
                {
                    field: {
                        fieldType: 'date',
                        fieldName: `${arrayName}[${number}].birthDate`,
                        grid: 6,
                        onChange: currentValue => searchHandler({ currentBirthDate: currentValue }),
                        errorMessage: 'Введите дату рождения',
                        placeholder: 'Дата рождения',
                        isDisabled: disableBirthDate,
                        isRequired: !disableBirthDate,
                        //validationType: maxAge ? 'minMaxDate' : undefined,
                        //minDate: maxAge ? dayjs().add(-maxAge, 'years').toDate() : undefined,
                    },
                },
                {
                    field: {
                        fieldType: 'radio',
                        fieldName: `${arrayName}[${number}].gender`,
                        grid: 6,
                        items: RADIO_SEX,
                        isDisabled: disableGender,
                    },
                },

                {
                    field: {
                        fieldType: 'inputMask',
                        fieldName: `${arrayName}[${number}].phoneMobile`,
                        isRequired: true,
                        debounceMs: 500,
                        grid: 6,
                        onChange: ev => searchHandler({ currentPhone: ev.target.value }),
                        mask: '+7 (999) 999-99-99',
                        validationType: 'phone',
                        errorMessage: 'Введите телефон',
                        placeholder: `Телефон`,
                    },
                },

                {
                    field: {
                        fieldType: 'input',
                        fieldName: `${arrayName}[${number}].email`,
                        isRequired: true,
                        isDisabled: contragentDisabled,
                        grid: 6,
                        validationType: 'email',
                        errorMessage: 'Введите e-mail',
                        placeholder: 'E-mail',
                    },
                },

                {
                    field: {
                        fieldType: 'element',
                        fieldName: 'blank1',
                        element: <></>,
                    }
                },

                {
                    field: {
                        fieldType: 'select',
                        fieldName: `${arrayName}[${number}].docType`,
                        isRequired: true,
                        placeholder: 'Документ',
                        items: [
                            {
                                label: "Паспорт гражданина РФ",
                                value: "0"
                            }
                        ],
                        grid: 6,
                        defaultValue: {
                            label: "Паспорт гражданина РФ",
                            value: "0"
                        }
                    },
                },

                {
                    field: {
                        fieldType: 'inputMask',
                        fieldName: `${arrayName}[${number}].docSeriesNumber`,
                        mask: '9999 999999',
                        grid: 6,
                        isRequired: true,
                        validationType: 'maskFilled',
                        errorMessage: 'Введите серию и номер паспорта',
                        placeholder: 'Серия и номер',
                    },
                },

                {
                    //isHidden: !authDocIssuerCode && isFlatMode && contragentDisabled,
                    field: {
                        fieldType: 'inputMask',
                        fieldName: `${arrayName}[${number}].authDocIssuerCode`,
                        isRequired: false,
                        isDisabled: contragentDisabled,
                        grid: 6,
                        mask: '999-999',
                        errorMessage: 'Введите код подразделения',
                        placeholder: 'Код подразделения',
                        validationType: 'authDocIssuerCode',
                        onChange: ev => searchByDocIssuerCode(ev.target.value),
                    },
                },

                {
                    field: {
                        fieldType: 'date',
                        fieldName: `${arrayName}[${number}].authDocDate`,
                        isRequired: true,
                        isDisabled: contragentDisabled,
                        grid: 6,
                        errorMessage: 'Введите дату выдачи паспорта',
                        placeholder: 'Дата выдачи паспорта',
                        validationType: 'minMaxDate',
                        maxDate: dayjs().toDate(),
                    },
                },

                {
                    field: {
                        fieldType: 'input',
                        fieldName: `${arrayName}[${number}].authDocIssuer`,
                        isRequired: true,
                        grid: 12,
                        isDisabled: contragentDisabled,
                        errorMessage: 'Введите кем выдан паспорт',
                        placeholder: 'Кем выдан',
                    },
                },

                {
                    field: {
                        fieldType: 'element',
                        fieldName: 'docIssurs',
                        element: codeResults && codeResults.length > 0 ?
                            <div style={{marginTop: '0'}}>
                                <Text4>Также найдено по коду подразделения: <br/>
                                    {codeResults.map((s) => (
                                        <>
                                            • <StyledDocResult onClick={() => onCodeResultClick(s)}>{s}</StyledDocResult><br/>
                                        </>))}
                                </Text4>
                                <br/>
                                <br/>
                            </div> : <></>,
                    }
                },


                {
                    field: {
                        fieldType: 'daData',
                        daDataType: 'address',
                        fieldName: `${arrayName}[${number}].addr1`,
                        placeholder: 'Адрес регистрации',
                        isRequired: true,
                        isDisabled: contragentDisabled,
                        validationType: 'addressWithHouse',
                        errorMessage: 'Введите адрес',
                    },
                },

                {
                    field: {
                        fieldType: 'checkbox',
                        fieldName: `${arrayName}[${number}].addressRadio`,
                        isDisabled: contragentDisabled,
                        label: 'Совпадает с адресом проживания',
                    },
                },
                {
                    isHidden: isSameAddress,
                    field: {
                        fieldType: 'daData',
                        daDataType: 'address',
                        fieldName: `${arrayName}[${number}].addr2`,
                        isRequired: true,
                        isDisabled: contragentDisabled,
                        validationType: 'addressWithHouse',
                        errorMessage: 'Введите адрес',
                        placeholder: 'Адрес проживания',
                    },
                },


                /*{
                    //isHidden: !isShowShare,
                    field: {
                        fieldType: 'range',
                        isRequired: true,
                        isDisabled: contragentDisabled,
                        errorMessage: 'Выберите долю',
                        fieldName: `${arrayName}[${number}].share`,
                        grid: 12,
                        placeholder: `Доля в общем доходе, %`,
                        min: 0,
                        max: 100,
                        step: 1,
                    },
                },*/



                /*{
                    field: {
                        fieldType: 'inputMask',
                        fieldName: `${arrayName}[${number}].authDocNumber`,
                        mask: '999999',
                        grid: 3,
                        isRequired: true,
                        isDisabled: contragentDisabled,
                        validationType: 'maskFilled',
                        errorMessage: 'Введите номер паспорта',
                        placeholder: 'Номер паспорта',
                    },
                },*/

            ],
        };



    return <FieldsBuilder {...form} />;
}

export default React.memo(Contragent);